import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Inventory, SearchCriteria } from '@raptor-fe/core';
import { ServiceUtils } from '../service-utils/service-utils';
import { LoadingHeaders } from '../web-loading-service/web-loading-headers';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class InventoryService {
    private readonly http = inject(HttpClient);
    private readonly serviceUtils = inject(ServiceUtils);
    private httpHeadersWithNoLoading = LoadingHeaders.httpHeadersWithNoLoading();

    search(tenantId: string, branchId: string, criteria: SearchCriteria, showLoading = true): Observable<Inventory[]> {
        return this.http.post<Inventory[]>(this.serviceUtils.getBaseUrl('inventory', tenantId, branchId) + `/search`, criteria, {
            headers: showLoading ? undefined : this.httpHeadersWithNoLoading,
        });    
    }

    searchByKeyword(
        tenantId: string,
        branchId: string,
        keyword: string,
        criteria: SearchCriteria,
        showLoading = true,
    ): Observable<Inventory[]> {
        let url = this.serviceUtils.getBaseUrl('inventory', tenantId, branchId) + `/search/keyword`;
        if (keyword && keyword.length > 0) url += `/${encodeURIComponent(keyword)}`;

        return this.http.post<Inventory[]>(url, criteria, {
            headers: showLoading ? undefined : this.httpHeadersWithNoLoading,
        });
    }

    get(tenantId: string, branchId: string, id: string): Observable<Inventory> {
        return this.http.get<Inventory>(this.serviceUtils.getBaseUrl('inventory', tenantId, branchId) + `/${id}`);
    }

    /**
     * Resolves a scanned barcode to inventory records for the branch.
     * Returns zero or one inventory carrying the matching part and its barcodes.
     * Uses the no-loading headers because it fires mid-scan and must not trigger the global spinner.
     */
    getByBarcode(tenantId: string, branchId: string, barcode: string): Observable<Inventory[]> {
        return this.http.get<Inventory[]>(
            this.serviceUtils.getBaseUrl('inventory', tenantId, branchId) + `/barcode/${encodeURIComponent(barcode)}`,
            {
                headers: this.httpHeadersWithNoLoading,
            },
        );
    }
}
